import { ReactNode, useEffect, useRef, useState } from "react";

import Image from "next/image";
import { HidingParent, Trigger } from "./FlashPCBCollapsibleStyles";

function defaultRenderTrigger(isExpanded: boolean) {
  return isExpanded ? "Collapse" : "Expand";
}

const FlashPCBExpandable = ({
  children,
  renderTrigger,
  triggerChildrenGap = "1rem",
}: {
  children: ReactNode;
  renderTrigger?: (isExpanded: boolean) => ReactNode | string;
  triggerChildrenGap?: string;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const childrenRef = useRef<HTMLDivElement>(null);
  const [childrenHeight, setChildrenHeight] = useState(0);

  useEffect(() => {
    const divElement = childrenRef.current;
    if (divElement !== null) {
      const observer = new ResizeObserver(() => {
        setChildrenHeight(divElement.scrollHeight);
      });
      observer.observe(divElement);

      return () => observer.disconnect();
    }
  }, []);

  const trigger =
    renderTrigger !== undefined
      ? renderTrigger(isExpanded)
      : defaultRenderTrigger(isExpanded);
  return (
    <div>
      <Trigger onClick={() => setIsExpanded((prevState) => !prevState)}>
        {isExpanded ? (
          <Image
            src="/icons/retract_red.svg"
            alt="Collapse"
            width="10"
            height="10"
          />
        ) : (
          <Image
            src="/icons/expand_red.svg"
            alt="Expand"
            width="10"
            height="10"
          />
        )}
        <div>{trigger}</div>
      </Trigger>
      <HidingParent show={isExpanded} height={`${childrenHeight}px`}>
        <div ref={childrenRef}>
          <div style={{ height: triggerChildrenGap }} />
          <div>{children}</div>
        </div>
      </HidingParent>
    </div>
  );
};

export default FlashPCBExpandable;
